// extracted by mini-css-extract-plugin
export default {"gift-icon":"_2U1Iz","giftIcon":"_2U1Iz","wiggle":"_1aQat"};